export const CARGOS_COLABORADORES = [
	"Diretor",
	"Encarregado",
	"Advogado",
	"Gerente operacional",
	"Gerente comercial",
	"Gerente",
	"Financeiro",
	"Coordenador",
	"Analista",
	"Supervisor",
	"Sócio",
];

export function isCargoColaboradorValido(cargo) {
	return Boolean(cargo) && CARGOS_COLABORADORES.includes(cargo);
}
